import { RadioButton, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const StyledRadioButton = styled(RadioButton)`
  display: flex;
  align-items: center;
  height: 3rem;
  font-weight: 400;

  > span {
    top: 1rem;
    border-color: ${theme.color.border.divider};
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
